module.exports = __webpack_public_path__ + "img/select-check-off.8a3e7880.svg";